import { Col, Divider, Row } from 'antd';
import propTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from '../../../components/buttons/buttons';
import DivBreak from '../../../components/divBreak/DivBreak';
import DeleteConfirmationModal from '../../../components/modals/DeleteConfirmationModal';
import FormUpload from '../../../components/upload/FormUpload';
import { deleteCarFile } from '../../../redux/car/actionCreator';
import { IMAGE_URL } from '../../../utils/constants';

const InspectionReportsForm = props => {
  const { values, setFieldValue, cancelModal, formData } = props;

  const params = useParams();
  const dispatch = useDispatch();
  const deleteImageLoading = useSelector(state => state.car.loading);

  const [deleteFile, setDeleteFile] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onCancel = () => {
    setShowDeleteModal(false);
    setDeleteFile(null);
    if (formData?.inspectionReports) {
      setFieldValue('inspectionReports', formData.inspectionReports);
    }
  };

  const handleDeleteClick = file => {
    // eslint-disable-next-line no-underscore-dangle
    if (values?._id && file) {
      if (file?.originFileObj) return;
      setShowDeleteModal(true);
      setDeleteFile(file);
    }
  };

  const handleDeleteConfirmation = async () => {
    const res = await dispatch(deleteCarFile(params?.id, deleteFile?.name, 'inspectionReport'));
    if (res?.data && res?.data?.status) {
      const remainingFiles = JSON.parse(res?.data?.car?.inspectionReports);

      const currentFiles = values.inspectionReports || [];
      const localFiles = currentFiles.filter(file => file.originFileObj);

      let allFiles = [];

      if (Array.isArray(remainingFiles) && remainingFiles.length > 0) {
        const remainingFilesInFile = remainingFiles.map((item, index) => {
          return {
            uid: `api-${index + 1}`,
            name: `${item}`,
            status: 'done',
            url: `${IMAGE_URL}/${item}`,
          };
        });
        allFiles = [...remainingFilesInFile, ...localFiles];
      } else {
        allFiles = localFiles;
      }

      setFieldValue('inspectionReports', allFiles);
      setShowDeleteModal(false);
    }
    setDeleteFile(null);
  };

  return (
    <>
      <DeleteConfirmationModal
        title="Inspection Report"
        visible={showDeleteModal}
        onCancel={onCancel}
        handleDeleteConfirmation={handleDeleteConfirmation}
        deleteButtonLoading={deleteImageLoading}
        itemName={deleteFile?.name}
      />
      {/* inspection reports */}
      <div className="add-product-block">
        <Row>
          <Col xs={24}>
            <FormUpload
              name="inspectionReports"
              label="Inspection Reports"
              value={values.inspectionReports}
              handleChange={info => {
                const fileList = [...info.fileList];
                setFieldValue('inspectionReports', fileList.length > 0 ? fileList : null);
              }}
              accept="application/pdf, image/jpeg, image/jpg"
              isMulti
              isRequired={false}
              onRemove={handleDeleteClick}
            />
          </Col>
        </Row>

        <DivBreak />
        <Divider />
        <Row justify="center" align="middle">
          <Button
            type="default"
            style={{ backgroundColor: '#155BDC', color: '#fff', height: '40px' }}
            onClick={e => {
              e.stopPropagation();
              cancelModal();
            }}
          >
            Save Inspection Reports
          </Button>
        </Row>
      </div>
    </>
  );
};

InspectionReportsForm.propTypes = {
  values: propTypes.object,
  setFieldValue: propTypes.func.isRequired,
  cancelModal: propTypes.func.isRequired,
  formData: propTypes.object.isRequired,
};

export default InspectionReportsForm;
